import { render, staticRenderFns } from "./ContractReview.vue?vue&type=template&id=085f6c34&scoped=true"
import script from "./ContractReview.vue?vue&type=script&lang=js"
export * from "./ContractReview.vue?vue&type=script&lang=js"
import style0 from "./ContractReview.vue?vue&type=style&index=0&id=085f6c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085f6c34",
  null
  
)

export default component.exports